import React from 'react';
import Dropzone, { FileRejection } from 'react-dropzone';
import { ReferralAttachmentType } from '../ReferralAttachments';

export interface ReferralFileUploadProps {
    attachments: ReferralAttachmentType[];
    setAttachments: React.Dispatch<React.SetStateAction<ReferralAttachmentType[]>>;
    editing: boolean;
    fileIncrement: number;
    setFileIncrement: React.Dispatch<React.SetStateAction<number>>;
}
export function ReferralFileUpload({
    attachments,
    setAttachments,
    editing,
    fileIncrement,
    setFileIncrement,
}: ReferralFileUploadProps) {
    const [error, setError] = React.useState<string[]>([]);

    const fileSuccess = React.useCallback(
        async (files: File[]) => {
            let totalSize = 0;
            attachments.forEach((attachment) => {
                totalSize += attachment.file.size;
            });
            files.forEach((file) => {
                totalSize += file.size;
            });
            if (totalSize > 50000000) {
                setError(['Total cumulative file size must not exceed 50MB.']);
            } else {
                let incrementId = fileIncrement;
                const newFiles = files.map((file) => {
                    incrementId += 1;
                    return { id: incrementId, file };
                });
                setFileIncrement(incrementId);
                setAttachments((prevAttachments) => [...prevAttachments, ...newFiles]);
            }
        },
        [attachments, setAttachments, fileIncrement, setFileIncrement]
    );

    function fileReject(files: FileRejection[]) {
        const errors: string[] = [];

        files.forEach((f) => {
            f.errors.forEach((e) => {
                errors.push(`${e.message} (${f.file.name})`);
            });
        });
        setError(errors);
    }

    function onDrop() {
        setError([]);
    }

    return (
        <>
            <Dropzone
                accept={['.pdf']}
                onDrop={onDrop}
                onDropAccepted={fileSuccess}
                onDropRejected={fileReject}
                disabled={editing}
            >
                {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps({ className: 'dropzone mb-3' })}>
                        <input {...getInputProps()} aria-label="Referral Attachments" />
                        Drop files to attach, or click to browse
                    </div>
                )}
            </Dropzone>
            {error.length > 0 && (
                <div className="mb-2">
                    {error.map((e) => (
                        <div key={e} className="text-danger fw-bold">
                            {e}
                        </div>
                    ))}
                </div>
            )}
        </>
    );
}
